var map = {
	"./de-DE/abandoned-cart": [
		56804,
		56804
	],
	"./de-DE/abandoned-cart.json": [
		56804,
		56804
	],
	"./de-DE/about-us": [
		58970,
		58970
	],
	"./de-DE/about-us.json": [
		58970,
		58970
	],
	"./de-DE/account-transactions": [
		16756,
		16756
	],
	"./de-DE/account-transactions.json": [
		16756,
		16756
	],
	"./de-DE/alerts-settings": [
		26347,
		26347
	],
	"./de-DE/alerts-settings.json": [
		26347,
		26347
	],
	"./de-DE/aria": [
		36597,
		36597
	],
	"./de-DE/aria.json": [
		36597,
		36597
	],
	"./de-DE/auto-savings": [
		99566,
		99566
	],
	"./de-DE/auto-savings.json": [
		99566,
		99566
	],
	"./de-DE/bad-request": [
		10534,
		10534
	],
	"./de-DE/bad-request.json": [
		10534,
		10534
	],
	"./de-DE/billing-address": [
		78454,
		41860
	],
	"./de-DE/billing-address.json": [
		78454,
		41860
	],
	"./de-DE/blog": [
		12605,
		12605
	],
	"./de-DE/blog-article": [
		92846,
		92846
	],
	"./de-DE/blog-article.json": [
		92846,
		92846
	],
	"./de-DE/blog-category": [
		41761,
		41761
	],
	"./de-DE/blog-category.json": [
		41761,
		41761
	],
	"./de-DE/blog-home": [
		95488,
		95488
	],
	"./de-DE/blog-home.json": [
		95488,
		95488
	],
	"./de-DE/blog-search": [
		62285,
		62285
	],
	"./de-DE/blog-search.json": [
		62285,
		62285
	],
	"./de-DE/blog-tag": [
		49714,
		49714
	],
	"./de-DE/blog-tag.json": [
		49714,
		49714
	],
	"./de-DE/blog.json": [
		12605,
		12605
	],
	"./de-DE/breadcrumb": [
		126,
		126
	],
	"./de-DE/breadcrumb.json": [
		126,
		126
	],
	"./de-DE/button": [
		18292,
		18292
	],
	"./de-DE/button.json": [
		18292,
		18292
	],
	"./de-DE/cart": [
		73103,
		73103
	],
	"./de-DE/cart.json": [
		73103,
		73103
	],
	"./de-DE/change-password": [
		92001,
		92001
	],
	"./de-DE/change-password.json": [
		92001,
		92001
	],
	"./de-DE/charts": [
		6584,
		6584
	],
	"./de-DE/charts.json": [
		6584,
		6584
	],
	"./de-DE/checkout": [
		7659,
		7659
	],
	"./de-DE/checkout-billing": [
		52346,
		52346
	],
	"./de-DE/checkout-billing.json": [
		52346,
		52346
	],
	"./de-DE/checkout-payment": [
		16387,
		16387
	],
	"./de-DE/checkout-payment.json": [
		16387,
		16387
	],
	"./de-DE/checkout-review": [
		38514,
		38514
	],
	"./de-DE/checkout-review.json": [
		38514,
		38514
	],
	"./de-DE/checkout-shipping": [
		83776,
		83776
	],
	"./de-DE/checkout-shipping.json": [
		83776,
		83776
	],
	"./de-DE/checkout-thank-you": [
		23135,
		23135
	],
	"./de-DE/checkout-thank-you.json": [
		23135,
		23135
	],
	"./de-DE/checkout.json": [
		7659,
		7659
	],
	"./de-DE/choice-purchasing-limit": [
		25289,
		25289
	],
	"./de-DE/choice-purchasing-limit.json": [
		25289,
		25289
	],
	"./de-DE/claims": [
		95971,
		95971
	],
	"./de-DE/claims.json": [
		95971,
		95971
	],
	"./de-DE/common": [
		26857,
		26857
	],
	"./de-DE/common.json": [
		26857,
		26857
	],
	"./de-DE/contact": [
		5840,
		5840
	],
	"./de-DE/contact-form": [
		34475,
		34475
	],
	"./de-DE/contact-form.json": [
		34475,
		34475
	],
	"./de-DE/contact.json": [
		5840,
		5840
	],
	"./de-DE/cookie-consent": [
		90386,
		90386
	],
	"./de-DE/cookie-consent.json": [
		90386,
		90386
	],
	"./de-DE/currency": [
		41751,
		10779
	],
	"./de-DE/currency.json": [
		41751,
		10779
	],
	"./de-DE/delivery-claims": [
		20428,
		20428
	],
	"./de-DE/delivery-claims-billing-address": [
		23156,
		23156
	],
	"./de-DE/delivery-claims-billing-address.json": [
		23156,
		23156
	],
	"./de-DE/delivery-claims-breakdown": [
		40791,
		40791
	],
	"./de-DE/delivery-claims-breakdown.json": [
		40791,
		40791
	],
	"./de-DE/delivery-claims-delivery": [
		96064,
		96064
	],
	"./de-DE/delivery-claims-delivery.json": [
		96064,
		96064
	],
	"./de-DE/delivery-claims-order-review": [
		22852,
		22852
	],
	"./de-DE/delivery-claims-order-review.json": [
		22852,
		22852
	],
	"./de-DE/delivery-claims-payment-method": [
		52171,
		52171
	],
	"./de-DE/delivery-claims-payment-method.json": [
		52171,
		52171
	],
	"./de-DE/delivery-claims-thank-you": [
		46527,
		46527
	],
	"./de-DE/delivery-claims-thank-you.json": [
		46527,
		46527
	],
	"./de-DE/delivery-claims.json": [
		20428,
		20428
	],
	"./de-DE/deposit": [
		33595,
		33595
	],
	"./de-DE/deposit.json": [
		33595,
		33595
	],
	"./de-DE/done-kyc": [
		68770,
		68770
	],
	"./de-DE/done-kyc.json": [
		68770,
		68770
	],
	"./de-DE/email-unsubscribe": [
		53535,
		53535
	],
	"./de-DE/email-unsubscribe.json": [
		53535,
		53535
	],
	"./de-DE/emergency-people": [
		16869,
		16869
	],
	"./de-DE/emergency-people.json": [
		16869,
		16869
	],
	"./de-DE/example": [
		88387,
		88387
	],
	"./de-DE/example.json": [
		88387,
		88387
	],
	"./de-DE/faq": [
		13593,
		88027
	],
	"./de-DE/faq-category": [
		60695,
		60695
	],
	"./de-DE/faq-category.json": [
		60695,
		60695
	],
	"./de-DE/faq-list": [
		84594,
		84594
	],
	"./de-DE/faq-list.json": [
		84594,
		84594
	],
	"./de-DE/faq-search": [
		17500,
		17500
	],
	"./de-DE/faq-search.json": [
		17500,
		17500
	],
	"./de-DE/faq.json": [
		13593,
		88027
	],
	"./de-DE/footer": [
		68255,
		68255
	],
	"./de-DE/footer.json": [
		68255,
		68255
	],
	"./de-DE/forgotten-password": [
		27273,
		27273
	],
	"./de-DE/forgotten-password.json": [
		27273,
		27273
	],
	"./de-DE/form": [
		80629,
		80629
	],
	"./de-DE/form.json": [
		80629,
		80629
	],
	"./de-DE/general-conditions": [
		18367,
		18367
	],
	"./de-DE/general-conditions.json": [
		18367,
		18367
	],
	"./de-DE/gift-confirmation": [
		90384,
		90384
	],
	"./de-DE/gift-confirmation.json": [
		90384,
		90384
	],
	"./de-DE/gift-detail": [
		32030,
		32030
	],
	"./de-DE/gift-detail.json": [
		32030,
		32030
	],
	"./de-DE/gift-list": [
		5415,
		5415
	],
	"./de-DE/gift-list.json": [
		5415,
		5415
	],
	"./de-DE/gift-pending": [
		852,
		852
	],
	"./de-DE/gift-pending.json": [
		852,
		852
	],
	"./de-DE/gift-recipient": [
		56056,
		56056
	],
	"./de-DE/gift-recipient.json": [
		56056,
		56056
	],
	"./de-DE/gift-submit": [
		39664,
		39664
	],
	"./de-DE/gift-submit.json": [
		39664,
		39664
	],
	"./de-DE/gifts": [
		90745,
		90745
	],
	"./de-DE/gifts.json": [
		90745,
		90745
	],
	"./de-DE/header": [
		61217,
		61217
	],
	"./de-DE/header.json": [
		61217,
		61217
	],
	"./de-DE/home": [
		40602,
		40602
	],
	"./de-DE/home-shop": [
		88430,
		88430
	],
	"./de-DE/home-shop.json": [
		88430,
		88430
	],
	"./de-DE/home.json": [
		40602,
		40602
	],
	"./de-DE/impressum": [
		23984,
		23984
	],
	"./de-DE/impressum.json": [
		23984,
		23984
	],
	"./de-DE/internal-error": [
		15274,
		15274
	],
	"./de-DE/internal-error.json": [
		15274,
		15274
	],
	"./de-DE/kyc": [
		60658,
		60658
	],
	"./de-DE/kyc-annual-income": [
		46132,
		46132
	],
	"./de-DE/kyc-annual-income.json": [
		46132,
		46132
	],
	"./de-DE/kyc-business-sector": [
		4386,
		4386
	],
	"./de-DE/kyc-business-sector.json": [
		4386,
		4386
	],
	"./de-DE/kyc-date-of-birth": [
		17482,
		17482
	],
	"./de-DE/kyc-date-of-birth.json": [
		17482,
		17482
	],
	"./de-DE/kyc-exposed-person": [
		37422,
		37422
	],
	"./de-DE/kyc-exposed-person.json": [
		37422,
		37422
	],
	"./de-DE/kyc-forecasted-annual-investments": [
		44749,
		44749
	],
	"./de-DE/kyc-forecasted-annual-investments.json": [
		44749,
		44749
	],
	"./de-DE/kyc-location": [
		90180,
		90180
	],
	"./de-DE/kyc-location.json": [
		90180,
		90180
	],
	"./de-DE/kyc-occupation": [
		24495,
		24495
	],
	"./de-DE/kyc-occupation.json": [
		24495,
		24495
	],
	"./de-DE/kyc-phone-number": [
		67979,
		67979
	],
	"./de-DE/kyc-phone-number.json": [
		67979,
		67979
	],
	"./de-DE/kyc-purchasing-limit": [
		26641,
		26641
	],
	"./de-DE/kyc-purchasing-limit.json": [
		26641,
		26641
	],
	"./de-DE/kyc-sources-of-funds": [
		53503,
		53503
	],
	"./de-DE/kyc-sources-of-funds.json": [
		53503,
		53503
	],
	"./de-DE/kyc.json": [
		60658,
		60658
	],
	"./de-DE/language": [
		62846,
		62846
	],
	"./de-DE/language.json": [
		62846,
		62846
	],
	"./de-DE/link": [
		59543,
		59543
	],
	"./de-DE/link.json": [
		59543,
		59543
	],
	"./de-DE/maintenance": [
		69471,
		69471
	],
	"./de-DE/maintenance.json": [
		69471,
		69471
	],
	"./de-DE/modal": [
		23411,
		23411
	],
	"./de-DE/modal.json": [
		23411,
		23411
	],
	"./de-DE/nationality": [
		89986,
		89986
	],
	"./de-DE/nationality.json": [
		89986,
		89986
	],
	"./de-DE/no_filename": [
		54708,
		54708
	],
	"./de-DE/no_filename.json": [
		54708,
		54708
	],
	"./de-DE/not-found": [
		81463,
		81463
	],
	"./de-DE/not-found.json": [
		81463,
		81463
	],
	"./de-DE/occupation": [
		93482,
		93482
	],
	"./de-DE/occupation.json": [
		93482,
		93482
	],
	"./de-DE/onfido": [
		14257,
		14257
	],
	"./de-DE/onfido.json": [
		14257,
		14257
	],
	"./de-DE/origin-of-funds": [
		67814,
		67814
	],
	"./de-DE/origin-of-funds.json": [
		67814,
		67814
	],
	"./de-DE/page-profile": [
		7916,
		7916
	],
	"./de-DE/page-profile.json": [
		7916,
		7916
	],
	"./de-DE/password-settings": [
		23731,
		23731
	],
	"./de-DE/password-settings.json": [
		23731,
		23731
	],
	"./de-DE/payments": [
		15637,
		15637
	],
	"./de-DE/payments.json": [
		15637,
		15637
	],
	"./de-DE/photo-identification": [
		79266,
		79266
	],
	"./de-DE/photo-identification.json": [
		79266,
		79266
	],
	"./de-DE/precious-metal": [
		43846,
		43846
	],
	"./de-DE/precious-metal.json": [
		43846,
		43846
	],
	"./de-DE/pricing": [
		63924,
		63924
	],
	"./de-DE/pricing.json": [
		63924,
		63924
	],
	"./de-DE/privacy": [
		97284,
		97284
	],
	"./de-DE/privacy.json": [
		97284,
		97284
	],
	"./de-DE/product": [
		7792,
		7792
	],
	"./de-DE/product-show": [
		76166,
		76166
	],
	"./de-DE/product-show.json": [
		76166,
		76166
	],
	"./de-DE/product.json": [
		7792,
		7792
	],
	"./de-DE/profile": [
		46071,
		46071
	],
	"./de-DE/profile.json": [
		46071,
		46071
	],
	"./de-DE/proof-of-address": [
		44952,
		44952
	],
	"./de-DE/proof-of-address.json": [
		44952,
		44952
	],
	"./de-DE/purchasing-limit": [
		57300,
		57300
	],
	"./de-DE/purchasing-limit.json": [
		57300,
		57300
	],
	"./de-DE/referral-terms": [
		10126,
		10126
	],
	"./de-DE/referral-terms.json": [
		10126,
		10126
	],
	"./de-DE/referrals": [
		72202,
		72202
	],
	"./de-DE/referrals.json": [
		72202,
		72202
	],
	"./de-DE/request-a-call": [
		21513,
		21513
	],
	"./de-DE/request-a-call.json": [
		21513,
		21513
	],
	"./de-DE/resend-instruction": [
		20257,
		20257
	],
	"./de-DE/resend-instruction.json": [
		20257,
		20257
	],
	"./de-DE/resend-instructions": [
		45317,
		45317
	],
	"./de-DE/resend-instructions.json": [
		45317,
		45317
	],
	"./de-DE/residence": [
		16040,
		16040
	],
	"./de-DE/residence.json": [
		16040,
		16040
	],
	"./de-DE/route": [
		89339,
		89339
	],
	"./de-DE/route.json": [
		89339,
		89339
	],
	"./de-DE/saving-assistant": [
		623,
		623
	],
	"./de-DE/saving-assistant.json": [
		623,
		623
	],
	"./de-DE/search": [
		17811,
		17811
	],
	"./de-DE/search.json": [
		17811,
		17811
	],
	"./de-DE/shipping-address": [
		88928,
		88928
	],
	"./de-DE/shipping-address.json": [
		88928,
		88928
	],
	"./de-DE/shop": [
		11126,
		11126
	],
	"./de-DE/shop-subcategory": [
		93719,
		93719
	],
	"./de-DE/shop-subcategory.json": [
		93719,
		93719
	],
	"./de-DE/shop.json": [
		11126,
		11126
	],
	"./de-DE/sign-in": [
		50938,
		50938
	],
	"./de-DE/sign-in.json": [
		50938,
		50938
	],
	"./de-DE/sign-up": [
		48574,
		48574
	],
	"./de-DE/sign-up.json": [
		48574,
		48574
	],
	"./de-DE/silver-landing": [
		53882,
		53882
	],
	"./de-DE/silver-landing.json": [
		53882,
		53882
	],
	"./de-DE/storage-fees": [
		90110,
		90110
	],
	"./de-DE/storage-fees.json": [
		90110,
		90110
	],
	"./de-DE/storage-solution": [
		81066,
		81066
	],
	"./de-DE/storage-solution.json": [
		81066,
		81066
	],
	"./de-DE/table": [
		6132,
		6132
	],
	"./de-DE/table.json": [
		6132,
		6132
	],
	"./de-DE/tooltip": [
		42122,
		42122
	],
	"./de-DE/tooltip.json": [
		42122,
		42122
	],
	"./de-DE/tutorial-video": [
		88735,
		88735
	],
	"./de-DE/tutorial-video.json": [
		88735,
		88735
	],
	"./de-DE/tutorial-videos": [
		72238,
		72238
	],
	"./de-DE/tutorial-videos.json": [
		72238,
		72238
	],
	"./de-DE/two-steps-auth": [
		81047,
		81047
	],
	"./de-DE/two-steps-auth-sms": [
		88586,
		88586
	],
	"./de-DE/two-steps-auth-sms.json": [
		88586,
		88586
	],
	"./de-DE/two-steps-auth-totp": [
		21933,
		21933
	],
	"./de-DE/two-steps-auth-totp.json": [
		21933,
		21933
	],
	"./de-DE/two-steps-auth.json": [
		81047,
		81047
	],
	"./de-DE/unlock-account": [
		41114,
		41114
	],
	"./de-DE/unlock-account.json": [
		41114,
		41114
	],
	"./de-DE/user": [
		72616,
		72616
	],
	"./de-DE/user.json": [
		72616,
		72616
	],
	"./de-DE/validator": [
		72244,
		72244
	],
	"./de-DE/validator.json": [
		72244,
		72244
	],
	"./de-DE/verify-auth": [
		90474,
		90474
	],
	"./de-DE/verify-auth.json": [
		90474,
		90474
	],
	"./de-DE/wallet": [
		25529,
		25529
	],
	"./de-DE/wallet-auto-savings": [
		55316,
		55316
	],
	"./de-DE/wallet-auto-savings-show": [
		42129,
		42129
	],
	"./de-DE/wallet-auto-savings-show.json": [
		42129,
		42129
	],
	"./de-DE/wallet-auto-savings.json": [
		55316,
		55316
	],
	"./de-DE/wallet-claim-show": [
		83983,
		83983
	],
	"./de-DE/wallet-claim-show.json": [
		83983,
		83983
	],
	"./de-DE/wallet-claims": [
		17957,
		17957
	],
	"./de-DE/wallet-claims.json": [
		17957,
		17957
	],
	"./de-DE/wallet-gift-show": [
		49713,
		49713
	],
	"./de-DE/wallet-gift-show.json": [
		49713,
		49713
	],
	"./de-DE/wallet-gifts": [
		52500,
		52500
	],
	"./de-DE/wallet-gifts.json": [
		52500,
		52500
	],
	"./de-DE/wallet-order-show": [
		82447,
		82447
	],
	"./de-DE/wallet-order-show.json": [
		82447,
		82447
	],
	"./de-DE/wallet-orders": [
		1561,
		1561
	],
	"./de-DE/wallet-orders.json": [
		1561,
		1561
	],
	"./de-DE/wallet-page": [
		53609,
		53609
	],
	"./de-DE/wallet-page.json": [
		53609,
		53609
	],
	"./de-DE/wallet-sell": [
		3149,
		3149
	],
	"./de-DE/wallet-sell-review": [
		59741,
		59741
	],
	"./de-DE/wallet-sell-review.json": [
		59741,
		59741
	],
	"./de-DE/wallet-sell-thanks": [
		72872,
		72872
	],
	"./de-DE/wallet-sell-thanks.json": [
		72872,
		72872
	],
	"./de-DE/wallet-sell.json": [
		3149,
		3149
	],
	"./de-DE/wallet.json": [
		25529,
		25529
	],
	"./de-DE/widget": [
		4411,
		4411
	],
	"./de-DE/widget.json": [
		4411,
		4411
	],
	"./de-DE/wishlist": [
		79373,
		79373
	],
	"./de-DE/wishlist.json": [
		79373,
		79373
	],
	"./de-DE/withdrawal": [
		70394,
		70394
	],
	"./de-DE/withdrawal.json": [
		70394,
		70394
	],
	"./de-DE/your-project": [
		26227,
		26227
	],
	"./de-DE/your-project.json": [
		26227,
		26227
	],
	"./en-US/abandoned-cart": [
		43102,
		43102
	],
	"./en-US/abandoned-cart.json": [
		43102,
		43102
	],
	"./en-US/about-us": [
		21541,
		21541
	],
	"./en-US/about-us.json": [
		21541,
		21541
	],
	"./en-US/account-transactions": [
		17290,
		17290
	],
	"./en-US/account-transactions.json": [
		17290,
		17290
	],
	"./en-US/alerts-settings": [
		53017,
		53017
	],
	"./en-US/alerts-settings.json": [
		53017,
		53017
	],
	"./en-US/aria": [
		89563,
		89563
	],
	"./en-US/aria.json": [
		89563,
		89563
	],
	"./en-US/auto-savings": [
		84910,
		84910
	],
	"./en-US/auto-savings.json": [
		84910,
		84910
	],
	"./en-US/bad-request": [
		81616,
		81616
	],
	"./en-US/bad-request.json": [
		81616,
		81616
	],
	"./en-US/billing-address": [
		43865,
		43865
	],
	"./en-US/billing-address.json": [
		43865,
		43865
	],
	"./en-US/blog": [
		93166,
		93166
	],
	"./en-US/blog-article": [
		96102,
		96102
	],
	"./en-US/blog-article.json": [
		96102,
		96102
	],
	"./en-US/blog-category": [
		8137,
		8137
	],
	"./en-US/blog-category.json": [
		8137,
		8137
	],
	"./en-US/blog-home": [
		36411,
		36411
	],
	"./en-US/blog-home.json": [
		36411,
		36411
	],
	"./en-US/blog-search": [
		98477,
		98477
	],
	"./en-US/blog-search.json": [
		98477,
		98477
	],
	"./en-US/blog-tag": [
		28607,
		28607
	],
	"./en-US/blog-tag.json": [
		28607,
		28607
	],
	"./en-US/blog.json": [
		93166,
		93166
	],
	"./en-US/breadcrumb": [
		95619,
		95619
	],
	"./en-US/breadcrumb.json": [
		95619,
		95619
	],
	"./en-US/button": [
		37094,
		37094
	],
	"./en-US/button.json": [
		37094,
		37094
	],
	"./en-US/cart": [
		53028,
		53028
	],
	"./en-US/cart.json": [
		53028,
		53028
	],
	"./en-US/change-password": [
		52663,
		52663
	],
	"./en-US/change-password.json": [
		52663,
		52663
	],
	"./en-US/charts": [
		41989,
		41989
	],
	"./en-US/charts.json": [
		41989,
		41989
	],
	"./en-US/checkout": [
		95931,
		95931
	],
	"./en-US/checkout-billing": [
		72474,
		72474
	],
	"./en-US/checkout-billing.json": [
		72474,
		72474
	],
	"./en-US/checkout-payment": [
		31658,
		31658
	],
	"./en-US/checkout-payment.json": [
		31658,
		31658
	],
	"./en-US/checkout-review": [
		37253,
		37253
	],
	"./en-US/checkout-review.json": [
		37253,
		37253
	],
	"./en-US/checkout-shipping": [
		88644,
		88644
	],
	"./en-US/checkout-shipping.json": [
		88644,
		88644
	],
	"./en-US/checkout-thank-you": [
		2676,
		2676
	],
	"./en-US/checkout-thank-you.json": [
		2676,
		2676
	],
	"./en-US/checkout.json": [
		95931,
		95931
	],
	"./en-US/choice-purchasing-limit": [
		42130,
		42130
	],
	"./en-US/choice-purchasing-limit.json": [
		42130,
		42130
	],
	"./en-US/claims": [
		97402,
		97402
	],
	"./en-US/claims.json": [
		97402,
		97402
	],
	"./en-US/common": [
		83428,
		83428
	],
	"./en-US/common.json": [
		83428,
		83428
	],
	"./en-US/contact": [
		18247,
		18247
	],
	"./en-US/contact-form": [
		61738,
		61738
	],
	"./en-US/contact-form.json": [
		61738,
		61738
	],
	"./en-US/contact.json": [
		18247,
		18247
	],
	"./en-US/cookie-consent": [
		91624,
		91624
	],
	"./en-US/cookie-consent.json": [
		91624,
		91624
	],
	"./en-US/currency": [
		89102,
		89102
	],
	"./en-US/currency.json": [
		89102,
		89102
	],
	"./en-US/delivery-claims": [
		87217,
		87217
	],
	"./en-US/delivery-claims-billing-address": [
		73726,
		73726
	],
	"./en-US/delivery-claims-billing-address.json": [
		73726,
		73726
	],
	"./en-US/delivery-claims-breakdown": [
		62098,
		62098
	],
	"./en-US/delivery-claims-breakdown.json": [
		62098,
		62098
	],
	"./en-US/delivery-claims-delivery": [
		87642,
		87642
	],
	"./en-US/delivery-claims-delivery.json": [
		87642,
		87642
	],
	"./en-US/delivery-claims-order-review": [
		88931,
		88931
	],
	"./en-US/delivery-claims-order-review.json": [
		88931,
		88931
	],
	"./en-US/delivery-claims-payment-method": [
		2726,
		2726
	],
	"./en-US/delivery-claims-payment-method.json": [
		2726,
		2726
	],
	"./en-US/delivery-claims-thank-you": [
		70699,
		70699
	],
	"./en-US/delivery-claims-thank-you.json": [
		70699,
		70699
	],
	"./en-US/delivery-claims.json": [
		87217,
		87217
	],
	"./en-US/deposit": [
		28954,
		28954
	],
	"./en-US/deposit.json": [
		28954,
		28954
	],
	"./en-US/done-kyc": [
		35816,
		35816
	],
	"./en-US/done-kyc.json": [
		35816,
		35816
	],
	"./en-US/email-unsubscribe": [
		38925,
		38925
	],
	"./en-US/email-unsubscribe.json": [
		38925,
		38925
	],
	"./en-US/emergency-people": [
		47337,
		47337
	],
	"./en-US/emergency-people.json": [
		47337,
		47337
	],
	"./en-US/example": [
		2962,
		2962
	],
	"./en-US/example.json": [
		2962,
		2962
	],
	"./en-US/faq": [
		51451,
		51451
	],
	"./en-US/faq-category": [
		8679,
		8679
	],
	"./en-US/faq-category.json": [
		8679,
		8679
	],
	"./en-US/faq-list": [
		22203,
		22203
	],
	"./en-US/faq-list.json": [
		22203,
		22203
	],
	"./en-US/faq-search": [
		34259,
		34259
	],
	"./en-US/faq-search.json": [
		34259,
		34259
	],
	"./en-US/faq.json": [
		51451,
		51451
	],
	"./en-US/footer": [
		42230,
		42230
	],
	"./en-US/footer.json": [
		42230,
		42230
	],
	"./en-US/forgotten-password": [
		43224,
		43224
	],
	"./en-US/forgotten-password.json": [
		43224,
		43224
	],
	"./en-US/form": [
		90532,
		90532
	],
	"./en-US/form.json": [
		90532,
		90532
	],
	"./en-US/general-conditions": [
		97676,
		97676
	],
	"./en-US/general-conditions.json": [
		97676,
		97676
	],
	"./en-US/gift-confirmation": [
		96410,
		96410
	],
	"./en-US/gift-confirmation.json": [
		96410,
		96410
	],
	"./en-US/gift-detail": [
		94237,
		94237
	],
	"./en-US/gift-detail.json": [
		94237,
		94237
	],
	"./en-US/gift-list": [
		2170,
		2170
	],
	"./en-US/gift-list.json": [
		2170,
		2170
	],
	"./en-US/gift-pending": [
		98572,
		98572
	],
	"./en-US/gift-pending.json": [
		98572,
		98572
	],
	"./en-US/gift-recipient": [
		49734,
		49734
	],
	"./en-US/gift-recipient.json": [
		49734,
		49734
	],
	"./en-US/gift-submit": [
		36938,
		36938
	],
	"./en-US/gift-submit.json": [
		36938,
		36938
	],
	"./en-US/gifts": [
		3684,
		3684
	],
	"./en-US/gifts.json": [
		3684,
		3684
	],
	"./en-US/header": [
		20509,
		20509
	],
	"./en-US/header.json": [
		20509,
		20509
	],
	"./en-US/home": [
		68068,
		68068
	],
	"./en-US/home-shop": [
		39809,
		39809
	],
	"./en-US/home-shop.json": [
		39809,
		39809
	],
	"./en-US/home.json": [
		68068,
		68068
	],
	"./en-US/impressum": [
		82548,
		82548
	],
	"./en-US/impressum.json": [
		82548,
		82548
	],
	"./en-US/internal-error": [
		24421,
		24421
	],
	"./en-US/internal-error.json": [
		24421,
		24421
	],
	"./en-US/kyc": [
		83936,
		83936
	],
	"./en-US/kyc-annual-income": [
		5537,
		5537
	],
	"./en-US/kyc-annual-income.json": [
		5537,
		5537
	],
	"./en-US/kyc-business-sector": [
		76063,
		76063
	],
	"./en-US/kyc-business-sector.json": [
		76063,
		76063
	],
	"./en-US/kyc-date-of-birth": [
		50999,
		50999
	],
	"./en-US/kyc-date-of-birth.json": [
		50999,
		50999
	],
	"./en-US/kyc-exposed-person": [
		11805,
		11805
	],
	"./en-US/kyc-exposed-person.json": [
		11805,
		11805
	],
	"./en-US/kyc-forecasted-annual-investments": [
		6011,
		6011
	],
	"./en-US/kyc-forecasted-annual-investments.json": [
		6011,
		6011
	],
	"./en-US/kyc-location": [
		86224,
		86224
	],
	"./en-US/kyc-location.json": [
		86224,
		86224
	],
	"./en-US/kyc-occupation": [
		77409,
		77409
	],
	"./en-US/kyc-occupation.json": [
		77409,
		77409
	],
	"./en-US/kyc-phone-number": [
		62544,
		62544
	],
	"./en-US/kyc-phone-number.json": [
		62544,
		62544
	],
	"./en-US/kyc-purchasing-limit": [
		72835,
		72835
	],
	"./en-US/kyc-purchasing-limit.json": [
		72835,
		72835
	],
	"./en-US/kyc-sources-of-funds": [
		55153,
		55153
	],
	"./en-US/kyc-sources-of-funds.json": [
		55153,
		55153
	],
	"./en-US/kyc.json": [
		83936,
		83936
	],
	"./en-US/language": [
		85693,
		85693
	],
	"./en-US/language.json": [
		85693,
		85693
	],
	"./en-US/link": [
		86785,
		86785
	],
	"./en-US/link.json": [
		86785,
		86785
	],
	"./en-US/maintenance": [
		83881,
		83881
	],
	"./en-US/maintenance.json": [
		83881,
		83881
	],
	"./en-US/modal": [
		43980,
		5735
	],
	"./en-US/modal.json": [
		43980,
		5735
	],
	"./en-US/nationality": [
		52639,
		52639
	],
	"./en-US/nationality.json": [
		52639,
		52639
	],
	"./en-US/no_filename": [
		24116,
		24116
	],
	"./en-US/no_filename.json": [
		24116,
		24116
	],
	"./en-US/not-found": [
		78631,
		78631
	],
	"./en-US/not-found.json": [
		78631,
		78631
	],
	"./en-US/occupation": [
		63965,
		63965
	],
	"./en-US/occupation.json": [
		63965,
		63965
	],
	"./en-US/onfido": [
		30532,
		30532
	],
	"./en-US/onfido.json": [
		30532,
		30532
	],
	"./en-US/origin-of-funds": [
		20284,
		20284
	],
	"./en-US/origin-of-funds.json": [
		20284,
		20284
	],
	"./en-US/page-profile": [
		99827,
		99827
	],
	"./en-US/page-profile.json": [
		99827,
		99827
	],
	"./en-US/password-settings": [
		19756,
		19756
	],
	"./en-US/password-settings.json": [
		19756,
		19756
	],
	"./en-US/payments": [
		33249,
		33249
	],
	"./en-US/payments.json": [
		33249,
		33249
	],
	"./en-US/photo-identification": [
		51641,
		51641
	],
	"./en-US/photo-identification.json": [
		51641,
		51641
	],
	"./en-US/precious-metal": [
		50609,
		50609
	],
	"./en-US/precious-metal.json": [
		50609,
		50609
	],
	"./en-US/pricing": [
		12883,
		12883
	],
	"./en-US/pricing.json": [
		12883,
		12883
	],
	"./en-US/privacy": [
		18557,
		18557
	],
	"./en-US/privacy.json": [
		18557,
		18557
	],
	"./en-US/product": [
		10644,
		10644
	],
	"./en-US/product-show": [
		38545,
		38545
	],
	"./en-US/product-show.json": [
		38545,
		38545
	],
	"./en-US/product.json": [
		10644,
		10644
	],
	"./en-US/profile": [
		42426,
		42426
	],
	"./en-US/profile.json": [
		42426,
		42426
	],
	"./en-US/proof-of-address": [
		57732,
		57732
	],
	"./en-US/proof-of-address.json": [
		57732,
		57732
	],
	"./en-US/purchasing-limit": [
		49384,
		49384
	],
	"./en-US/purchasing-limit.json": [
		49384,
		49384
	],
	"./en-US/referral-terms": [
		15622,
		15622
	],
	"./en-US/referral-terms.json": [
		15622,
		15622
	],
	"./en-US/referrals": [
		27951,
		27951
	],
	"./en-US/referrals.json": [
		27951,
		27951
	],
	"./en-US/request-a-call": [
		36886,
		36886
	],
	"./en-US/request-a-call.json": [
		36886,
		36886
	],
	"./en-US/resend-instruction": [
		39805,
		39805
	],
	"./en-US/resend-instruction.json": [
		39805,
		39805
	],
	"./en-US/resend-instructions": [
		97929,
		97929
	],
	"./en-US/resend-instructions.json": [
		97929,
		97929
	],
	"./en-US/residence": [
		94468,
		94468
	],
	"./en-US/residence.json": [
		94468,
		94468
	],
	"./en-US/route": [
		31238,
		31238
	],
	"./en-US/route.json": [
		31238,
		31238
	],
	"./en-US/saving-assistant": [
		48773,
		48773
	],
	"./en-US/saving-assistant.json": [
		48773,
		48773
	],
	"./en-US/search": [
		45339,
		45339
	],
	"./en-US/search.json": [
		45339,
		45339
	],
	"./en-US/shipping-address": [
		1934,
		1934
	],
	"./en-US/shipping-address.json": [
		1934,
		1934
	],
	"./en-US/shop": [
		37645,
		37645
	],
	"./en-US/shop-subcategory": [
		69039,
		69039
	],
	"./en-US/shop-subcategory.json": [
		69039,
		69039
	],
	"./en-US/shop.json": [
		37645,
		37645
	],
	"./en-US/sign-in": [
		32157,
		32157
	],
	"./en-US/sign-in.json": [
		32157,
		32157
	],
	"./en-US/sign-up": [
		16600,
		16600
	],
	"./en-US/sign-up.json": [
		16600,
		16600
	],
	"./en-US/silver-landing": [
		76440,
		76440
	],
	"./en-US/silver-landing.json": [
		76440,
		76440
	],
	"./en-US/storage-fees": [
		61810,
		61810
	],
	"./en-US/storage-fees.json": [
		61810,
		61810
	],
	"./en-US/storage-solution": [
		62345,
		62345
	],
	"./en-US/storage-solution.json": [
		62345,
		62345
	],
	"./en-US/table": [
		37996,
		37996
	],
	"./en-US/table.json": [
		37996,
		37996
	],
	"./en-US/tooltip": [
		82885,
		82885
	],
	"./en-US/tooltip.json": [
		82885,
		82885
	],
	"./en-US/tutorial-video": [
		6243,
		6243
	],
	"./en-US/tutorial-video.json": [
		6243,
		6243
	],
	"./en-US/tutorial-videos": [
		54392,
		54392
	],
	"./en-US/tutorial-videos.json": [
		54392,
		54392
	],
	"./en-US/two-steps-auth": [
		35547,
		35547
	],
	"./en-US/two-steps-auth-sms": [
		19287,
		19287
	],
	"./en-US/two-steps-auth-sms.json": [
		19287,
		19287
	],
	"./en-US/two-steps-auth-totp": [
		85727,
		85727
	],
	"./en-US/two-steps-auth-totp.json": [
		85727,
		85727
	],
	"./en-US/two-steps-auth.json": [
		35547,
		35547
	],
	"./en-US/unlock-account": [
		58788,
		58788
	],
	"./en-US/unlock-account.json": [
		58788,
		58788
	],
	"./en-US/user": [
		66531,
		66531
	],
	"./en-US/user.json": [
		66531,
		66531
	],
	"./en-US/validator": [
		73814,
		73814
	],
	"./en-US/validator.json": [
		73814,
		73814
	],
	"./en-US/verify-auth": [
		24277,
		43980
	],
	"./en-US/verify-auth.json": [
		24277,
		43980
	],
	"./en-US/wallet": [
		35539,
		35539
	],
	"./en-US/wallet-auto-savings": [
		50658,
		50658
	],
	"./en-US/wallet-auto-savings-show": [
		34850,
		34850
	],
	"./en-US/wallet-auto-savings-show.json": [
		34850,
		34850
	],
	"./en-US/wallet-auto-savings.json": [
		50658,
		50658
	],
	"./en-US/wallet-claim-show": [
		28003,
		28003
	],
	"./en-US/wallet-claim-show.json": [
		28003,
		28003
	],
	"./en-US/wallet-claims": [
		85969,
		85969
	],
	"./en-US/wallet-claims.json": [
		85969,
		85969
	],
	"./en-US/wallet-gift-show": [
		25668,
		25668
	],
	"./en-US/wallet-gift-show.json": [
		25668,
		25668
	],
	"./en-US/wallet-gifts": [
		91544,
		91544
	],
	"./en-US/wallet-gifts.json": [
		91544,
		91544
	],
	"./en-US/wallet-order-show": [
		74067,
		74067
	],
	"./en-US/wallet-order-show.json": [
		74067,
		74067
	],
	"./en-US/wallet-orders": [
		77331,
		77331
	],
	"./en-US/wallet-orders.json": [
		77331,
		77331
	],
	"./en-US/wallet-page": [
		95505,
		95505
	],
	"./en-US/wallet-page.json": [
		95505,
		95505
	],
	"./en-US/wallet-sell": [
		87866,
		87866
	],
	"./en-US/wallet-sell-review": [
		48204,
		48204
	],
	"./en-US/wallet-sell-review.json": [
		48204,
		48204
	],
	"./en-US/wallet-sell-thanks": [
		90051,
		90051
	],
	"./en-US/wallet-sell-thanks.json": [
		90051,
		90051
	],
	"./en-US/wallet-sell.json": [
		87866,
		87866
	],
	"./en-US/wallet.json": [
		35539,
		35539
	],
	"./en-US/widget": [
		97947,
		97947
	],
	"./en-US/widget.json": [
		97947,
		97947
	],
	"./en-US/wishlist": [
		48057,
		48057
	],
	"./en-US/wishlist.json": [
		48057,
		48057
	],
	"./en-US/withdrawal": [
		63932,
		63932
	],
	"./en-US/withdrawal.json": [
		63932,
		63932
	],
	"./en-US/your-project": [
		40013,
		40013
	],
	"./en-US/your-project.json": [
		40013,
		40013
	],
	"./fr-FR/abandoned-cart": [
		44064,
		44064
	],
	"./fr-FR/abandoned-cart.json": [
		44064,
		44064
	],
	"./fr-FR/about-us": [
		20799,
		20799
	],
	"./fr-FR/about-us.json": [
		20799,
		20799
	],
	"./fr-FR/account-transactions": [
		70542,
		70542
	],
	"./fr-FR/account-transactions.json": [
		70542,
		70542
	],
	"./fr-FR/alerts-settings": [
		59099,
		59099
	],
	"./fr-FR/alerts-settings.json": [
		59099,
		59099
	],
	"./fr-FR/aria": [
		49392,
		49392
	],
	"./fr-FR/aria.json": [
		49392,
		49392
	],
	"./fr-FR/auto-savings": [
		73127,
		73127
	],
	"./fr-FR/auto-savings.json": [
		73127,
		73127
	],
	"./fr-FR/bad-request": [
		11026,
		11026
	],
	"./fr-FR/bad-request.json": [
		11026,
		11026
	],
	"./fr-FR/billing-address": [
		62353,
		62353
	],
	"./fr-FR/billing-address.json": [
		62353,
		62353
	],
	"./fr-FR/blog": [
		87919,
		87919
	],
	"./fr-FR/blog-article": [
		82261,
		82261
	],
	"./fr-FR/blog-article.json": [
		82261,
		82261
	],
	"./fr-FR/blog-category": [
		27378,
		27378
	],
	"./fr-FR/blog-category.json": [
		27378,
		27378
	],
	"./fr-FR/blog-home": [
		3594,
		3594
	],
	"./fr-FR/blog-home.json": [
		3594,
		3594
	],
	"./fr-FR/blog-search": [
		6809,
		6809
	],
	"./fr-FR/blog-search.json": [
		6809,
		6809
	],
	"./fr-FR/blog-tag": [
		12996,
		12996
	],
	"./fr-FR/blog-tag.json": [
		12996,
		12996
	],
	"./fr-FR/blog.json": [
		87919,
		87919
	],
	"./fr-FR/breadcrumb": [
		37183,
		24115
	],
	"./fr-FR/breadcrumb.json": [
		37183,
		24115
	],
	"./fr-FR/button": [
		82852,
		82852
	],
	"./fr-FR/button.json": [
		82852,
		82852
	],
	"./fr-FR/cart": [
		16097,
		16097
	],
	"./fr-FR/cart.json": [
		16097,
		16097
	],
	"./fr-FR/change-password": [
		13294,
		13294
	],
	"./fr-FR/change-password.json": [
		13294,
		13294
	],
	"./fr-FR/charts": [
		4641,
		4641
	],
	"./fr-FR/charts.json": [
		4641,
		4641
	],
	"./fr-FR/checkout": [
		72697,
		72697
	],
	"./fr-FR/checkout-billing": [
		33815,
		33815
	],
	"./fr-FR/checkout-billing.json": [
		33815,
		33815
	],
	"./fr-FR/checkout-payment": [
		59653,
		59653
	],
	"./fr-FR/checkout-payment.json": [
		59653,
		59653
	],
	"./fr-FR/checkout-review": [
		8982,
		8982
	],
	"./fr-FR/checkout-review.json": [
		8982,
		8982
	],
	"./fr-FR/checkout-shipping": [
		77733,
		77733
	],
	"./fr-FR/checkout-shipping.json": [
		77733,
		77733
	],
	"./fr-FR/checkout-thank-you": [
		76297,
		76297
	],
	"./fr-FR/checkout-thank-you.json": [
		76297,
		76297
	],
	"./fr-FR/checkout.json": [
		72697,
		72697
	],
	"./fr-FR/choice-purchasing-limit": [
		55264,
		55264
	],
	"./fr-FR/choice-purchasing-limit.json": [
		55264,
		55264
	],
	"./fr-FR/claims": [
		81451,
		81451
	],
	"./fr-FR/claims.json": [
		81451,
		81451
	],
	"./fr-FR/common": [
		57321,
		57321
	],
	"./fr-FR/common.json": [
		57321,
		57321
	],
	"./fr-FR/contact": [
		87286,
		87286
	],
	"./fr-FR/contact-form": [
		6031,
		6031
	],
	"./fr-FR/contact-form.json": [
		6031,
		6031
	],
	"./fr-FR/contact.json": [
		87286,
		87286
	],
	"./fr-FR/cookie-consent": [
		43571,
		43571
	],
	"./fr-FR/cookie-consent.json": [
		43571,
		43571
	],
	"./fr-FR/currency": [
		98434,
		98434
	],
	"./fr-FR/currency.json": [
		98434,
		98434
	],
	"./fr-FR/delivery-claims": [
		88335,
		88335
	],
	"./fr-FR/delivery-claims-billing-address": [
		10025,
		10025
	],
	"./fr-FR/delivery-claims-billing-address.json": [
		10025,
		10025
	],
	"./fr-FR/delivery-claims-breakdown": [
		35002,
		35002
	],
	"./fr-FR/delivery-claims-breakdown.json": [
		35002,
		35002
	],
	"./fr-FR/delivery-claims-delivery": [
		42443,
		42443
	],
	"./fr-FR/delivery-claims-delivery.json": [
		42443,
		42443
	],
	"./fr-FR/delivery-claims-order-review": [
		62614,
		62614
	],
	"./fr-FR/delivery-claims-order-review.json": [
		62614,
		62614
	],
	"./fr-FR/delivery-claims-payment-method": [
		64733,
		64733
	],
	"./fr-FR/delivery-claims-payment-method.json": [
		64733,
		64733
	],
	"./fr-FR/delivery-claims-thank-you": [
		97880,
		97880
	],
	"./fr-FR/delivery-claims-thank-you.json": [
		97880,
		97880
	],
	"./fr-FR/delivery-claims.json": [
		88335,
		88335
	],
	"./fr-FR/deposit": [
		31508,
		31508
	],
	"./fr-FR/deposit.json": [
		31508,
		31508
	],
	"./fr-FR/done-kyc": [
		47972,
		47972
	],
	"./fr-FR/done-kyc.json": [
		47972,
		47972
	],
	"./fr-FR/email-unsubscribe": [
		17932,
		17932
	],
	"./fr-FR/email-unsubscribe.json": [
		17932,
		17932
	],
	"./fr-FR/emergency-people": [
		68730,
		68730
	],
	"./fr-FR/emergency-people.json": [
		68730,
		68730
	],
	"./fr-FR/example": [
		61402,
		61402
	],
	"./fr-FR/example.json": [
		61402,
		61402
	],
	"./fr-FR/faq": [
		38098,
		38098
	],
	"./fr-FR/faq-category": [
		60394,
		60394
	],
	"./fr-FR/faq-category.json": [
		60394,
		60394
	],
	"./fr-FR/faq-list": [
		49476,
		49476
	],
	"./fr-FR/faq-list.json": [
		49476,
		49476
	],
	"./fr-FR/faq-search": [
		28847,
		28847
	],
	"./fr-FR/faq-search.json": [
		28847,
		28847
	],
	"./fr-FR/faq.json": [
		38098,
		38098
	],
	"./fr-FR/footer": [
		32743,
		32743
	],
	"./fr-FR/footer.json": [
		32743,
		32743
	],
	"./fr-FR/forgotten-password": [
		69451,
		69451
	],
	"./fr-FR/forgotten-password.json": [
		69451,
		69451
	],
	"./fr-FR/form": [
		8574,
		8574
	],
	"./fr-FR/form.json": [
		8574,
		8574
	],
	"./fr-FR/general-conditions": [
		85826,
		85826
	],
	"./fr-FR/general-conditions.json": [
		85826,
		85826
	],
	"./fr-FR/gift-confirmation": [
		76981,
		76981
	],
	"./fr-FR/gift-confirmation.json": [
		76981,
		76981
	],
	"./fr-FR/gift-detail": [
		96494,
		96494
	],
	"./fr-FR/gift-detail.json": [
		96494,
		96494
	],
	"./fr-FR/gift-list": [
		48536,
		48536
	],
	"./fr-FR/gift-list.json": [
		48536,
		48536
	],
	"./fr-FR/gift-pending": [
		37978,
		37978
	],
	"./fr-FR/gift-pending.json": [
		37978,
		37978
	],
	"./fr-FR/gift-recipient": [
		27362,
		27362
	],
	"./fr-FR/gift-recipient.json": [
		27362,
		27362
	],
	"./fr-FR/gift-submit": [
		1585,
		1585
	],
	"./fr-FR/gift-submit.json": [
		1585,
		1585
	],
	"./fr-FR/gifts": [
		4509,
		4509
	],
	"./fr-FR/gifts.json": [
		4509,
		4509
	],
	"./fr-FR/header": [
		47711,
		47711
	],
	"./fr-FR/header.json": [
		47711,
		47711
	],
	"./fr-FR/home": [
		183,
		183
	],
	"./fr-FR/home-shop": [
		53341,
		53341
	],
	"./fr-FR/home-shop.json": [
		53341,
		53341
	],
	"./fr-FR/home.json": [
		183,
		183
	],
	"./fr-FR/impressum": [
		95626,
		95626
	],
	"./fr-FR/impressum.json": [
		95626,
		95626
	],
	"./fr-FR/internal-error": [
		8333,
		8333
	],
	"./fr-FR/internal-error.json": [
		8333,
		8333
	],
	"./fr-FR/kyc": [
		63019,
		63019
	],
	"./fr-FR/kyc-annual-income": [
		22241,
		22241
	],
	"./fr-FR/kyc-annual-income.json": [
		22241,
		22241
	],
	"./fr-FR/kyc-business-sector": [
		84223,
		84223
	],
	"./fr-FR/kyc-business-sector.json": [
		84223,
		84223
	],
	"./fr-FR/kyc-date-of-birth": [
		75730,
		75730
	],
	"./fr-FR/kyc-date-of-birth.json": [
		75730,
		75730
	],
	"./fr-FR/kyc-exposed-person": [
		85237,
		85237
	],
	"./fr-FR/kyc-exposed-person.json": [
		85237,
		85237
	],
	"./fr-FR/kyc-forecasted-annual-investments": [
		35598,
		35598
	],
	"./fr-FR/kyc-forecasted-annual-investments.json": [
		35598,
		35598
	],
	"./fr-FR/kyc-location": [
		46547,
		46547
	],
	"./fr-FR/kyc-location.json": [
		46547,
		46547
	],
	"./fr-FR/kyc-occupation": [
		86006,
		86006
	],
	"./fr-FR/kyc-occupation.json": [
		86006,
		86006
	],
	"./fr-FR/kyc-phone-number": [
		34538,
		34538
	],
	"./fr-FR/kyc-phone-number.json": [
		34538,
		34538
	],
	"./fr-FR/kyc-purchasing-limit": [
		40182,
		40182
	],
	"./fr-FR/kyc-purchasing-limit.json": [
		40182,
		40182
	],
	"./fr-FR/kyc-sources-of-funds": [
		87950,
		87950
	],
	"./fr-FR/kyc-sources-of-funds.json": [
		87950,
		87950
	],
	"./fr-FR/kyc.json": [
		63019,
		63019
	],
	"./fr-FR/language": [
		83580,
		83580
	],
	"./fr-FR/language.json": [
		83580,
		83580
	],
	"./fr-FR/link": [
		99055,
		99055
	],
	"./fr-FR/link.json": [
		99055,
		99055
	],
	"./fr-FR/maintenance": [
		54080,
		54080
	],
	"./fr-FR/maintenance.json": [
		54080,
		54080
	],
	"./fr-FR/modal": [
		14474,
		14474
	],
	"./fr-FR/modal.json": [
		14474,
		14474
	],
	"./fr-FR/nationality": [
		5097,
		5097
	],
	"./fr-FR/nationality.json": [
		5097,
		5097
	],
	"./fr-FR/no_filename": [
		41948,
		41948
	],
	"./fr-FR/no_filename.json": [
		41948,
		41948
	],
	"./fr-FR/not-found": [
		31266,
		31266
	],
	"./fr-FR/not-found.json": [
		31266,
		31266
	],
	"./fr-FR/occupation": [
		32594,
		32594
	],
	"./fr-FR/occupation.json": [
		32594,
		32594
	],
	"./fr-FR/onfido": [
		84344,
		84344
	],
	"./fr-FR/onfido.json": [
		84344,
		84344
	],
	"./fr-FR/origin-of-funds": [
		32823,
		32823
	],
	"./fr-FR/origin-of-funds.json": [
		32823,
		32823
	],
	"./fr-FR/page-profile": [
		77914,
		77914
	],
	"./fr-FR/page-profile.json": [
		77914,
		77914
	],
	"./fr-FR/password-settings": [
		42131,
		42131
	],
	"./fr-FR/password-settings.json": [
		42131,
		42131
	],
	"./fr-FR/payments": [
		44948,
		44948
	],
	"./fr-FR/payments.json": [
		44948,
		44948
	],
	"./fr-FR/photo-identification": [
		65380,
		65380
	],
	"./fr-FR/photo-identification.json": [
		65380,
		65380
	],
	"./fr-FR/precious-metal": [
		1384,
		1384
	],
	"./fr-FR/precious-metal.json": [
		1384,
		1384
	],
	"./fr-FR/pricing": [
		49130,
		49130
	],
	"./fr-FR/pricing.json": [
		49130,
		49130
	],
	"./fr-FR/privacy": [
		40009,
		40009
	],
	"./fr-FR/privacy.json": [
		40009,
		40009
	],
	"./fr-FR/product": [
		96030,
		96030
	],
	"./fr-FR/product-show": [
		22328,
		22328
	],
	"./fr-FR/product-show.json": [
		22328,
		22328
	],
	"./fr-FR/product.json": [
		96030,
		96030
	],
	"./fr-FR/profile": [
		96963,
		96963
	],
	"./fr-FR/profile.json": [
		96963,
		96963
	],
	"./fr-FR/proof-of-address": [
		97001,
		97001
	],
	"./fr-FR/proof-of-address.json": [
		97001,
		97001
	],
	"./fr-FR/purchasing-limit": [
		50733,
		50733
	],
	"./fr-FR/purchasing-limit.json": [
		50733,
		50733
	],
	"./fr-FR/referral-terms": [
		62695,
		62695
	],
	"./fr-FR/referral-terms.json": [
		62695,
		62695
	],
	"./fr-FR/referrals": [
		3315,
		3315
	],
	"./fr-FR/referrals.json": [
		3315,
		3315
	],
	"./fr-FR/request-a-call": [
		42148,
		99698
	],
	"./fr-FR/request-a-call.json": [
		42148,
		99698
	],
	"./fr-FR/resend-instruction": [
		74934,
		74934
	],
	"./fr-FR/resend-instruction.json": [
		74934,
		74934
	],
	"./fr-FR/resend-instructions": [
		73066,
		73066
	],
	"./fr-FR/resend-instructions.json": [
		73066,
		73066
	],
	"./fr-FR/residence": [
		32231,
		32231
	],
	"./fr-FR/residence.json": [
		32231,
		32231
	],
	"./fr-FR/route": [
		85759,
		85759
	],
	"./fr-FR/route.json": [
		85759,
		85759
	],
	"./fr-FR/saving-assistant": [
		84510,
		84510
	],
	"./fr-FR/saving-assistant.json": [
		84510,
		84510
	],
	"./fr-FR/search": [
		67083,
		67083
	],
	"./fr-FR/search.json": [
		67083,
		67083
	],
	"./fr-FR/shipping-address": [
		30833,
		30833
	],
	"./fr-FR/shipping-address.json": [
		30833,
		30833
	],
	"./fr-FR/shop": [
		87970,
		87970
	],
	"./fr-FR/shop-subcategory": [
		66066,
		66066
	],
	"./fr-FR/shop-subcategory.json": [
		66066,
		66066
	],
	"./fr-FR/shop.json": [
		87970,
		87970
	],
	"./fr-FR/sign-in": [
		33242,
		33242
	],
	"./fr-FR/sign-in.json": [
		33242,
		33242
	],
	"./fr-FR/sign-up": [
		19580,
		19580
	],
	"./fr-FR/sign-up.json": [
		19580,
		19580
	],
	"./fr-FR/silver-landing": [
		41185,
		41185
	],
	"./fr-FR/silver-landing.json": [
		41185,
		41185
	],
	"./fr-FR/storage-fees": [
		90558,
		90558
	],
	"./fr-FR/storage-fees.json": [
		90558,
		90558
	],
	"./fr-FR/storage-solution": [
		17223,
		17223
	],
	"./fr-FR/storage-solution.json": [
		17223,
		17223
	],
	"./fr-FR/table": [
		22889,
		22889
	],
	"./fr-FR/table.json": [
		22889,
		22889
	],
	"./fr-FR/tooltip": [
		99610,
		99610
	],
	"./fr-FR/tooltip.json": [
		99610,
		99610
	],
	"./fr-FR/tutorial-video": [
		99665,
		99665
	],
	"./fr-FR/tutorial-video.json": [
		99665,
		99665
	],
	"./fr-FR/tutorial-videos": [
		24953,
		24953
	],
	"./fr-FR/tutorial-videos.json": [
		24953,
		24953
	],
	"./fr-FR/two-steps-auth": [
		46005,
		46005
	],
	"./fr-FR/two-steps-auth-sms": [
		36943,
		36943
	],
	"./fr-FR/two-steps-auth-sms.json": [
		36943,
		36943
	],
	"./fr-FR/two-steps-auth-totp": [
		24450,
		24450
	],
	"./fr-FR/two-steps-auth-totp.json": [
		24450,
		24450
	],
	"./fr-FR/two-steps-auth.json": [
		46005,
		46005
	],
	"./fr-FR/unlock-account": [
		9923,
		9923
	],
	"./fr-FR/unlock-account.json": [
		9923,
		9923
	],
	"./fr-FR/user": [
		25622,
		25622
	],
	"./fr-FR/user.json": [
		25622,
		25622
	],
	"./fr-FR/validator": [
		17668,
		17668
	],
	"./fr-FR/validator.json": [
		17668,
		17668
	],
	"./fr-FR/verify-auth": [
		90437,
		90437
	],
	"./fr-FR/verify-auth.json": [
		90437,
		90437
	],
	"./fr-FR/wallet": [
		43297,
		43297
	],
	"./fr-FR/wallet-auto-savings": [
		69563,
		69563
	],
	"./fr-FR/wallet-auto-savings-show": [
		99884,
		99884
	],
	"./fr-FR/wallet-auto-savings-show.json": [
		99884,
		99884
	],
	"./fr-FR/wallet-auto-savings.json": [
		69563,
		69563
	],
	"./fr-FR/wallet-claim-show": [
		54219,
		54219
	],
	"./fr-FR/wallet-claim-show.json": [
		54219,
		54219
	],
	"./fr-FR/wallet-claims": [
		12428,
		12428
	],
	"./fr-FR/wallet-claims.json": [
		12428,
		12428
	],
	"./fr-FR/wallet-gift-show": [
		11227,
		11227
	],
	"./fr-FR/wallet-gift-show.json": [
		11227,
		11227
	],
	"./fr-FR/wallet-gifts": [
		32538,
		32538
	],
	"./fr-FR/wallet-gifts.json": [
		32538,
		32538
	],
	"./fr-FR/wallet-order-show": [
		73949,
		73949
	],
	"./fr-FR/wallet-order-show.json": [
		73949,
		73949
	],
	"./fr-FR/wallet-orders": [
		95460,
		95460
	],
	"./fr-FR/wallet-orders.json": [
		95460,
		95460
	],
	"./fr-FR/wallet-page": [
		28659,
		28659
	],
	"./fr-FR/wallet-page.json": [
		28659,
		28659
	],
	"./fr-FR/wallet-sell": [
		55893,
		55893
	],
	"./fr-FR/wallet-sell-review": [
		21084,
		21084
	],
	"./fr-FR/wallet-sell-review.json": [
		21084,
		21084
	],
	"./fr-FR/wallet-sell-thanks": [
		20805,
		20805
	],
	"./fr-FR/wallet-sell-thanks.json": [
		20805,
		20805
	],
	"./fr-FR/wallet-sell.json": [
		55893,
		55893
	],
	"./fr-FR/wallet.json": [
		43297,
		43297
	],
	"./fr-FR/widget": [
		75633,
		75633
	],
	"./fr-FR/widget.json": [
		75633,
		75633
	],
	"./fr-FR/wishlist": [
		61871,
		61871
	],
	"./fr-FR/wishlist.json": [
		61871,
		61871
	],
	"./fr-FR/withdrawal": [
		87814,
		87814
	],
	"./fr-FR/withdrawal.json": [
		87814,
		87814
	],
	"./fr-FR/your-project": [
		14070,
		14070
	],
	"./fr-FR/your-project.json": [
		14070,
		14070
	],
	"./it-IT/abandoned-cart": [
		23418,
		23418
	],
	"./it-IT/abandoned-cart.json": [
		23418,
		23418
	],
	"./it-IT/about-us": [
		57470,
		57470
	],
	"./it-IT/about-us.json": [
		57470,
		57470
	],
	"./it-IT/account-transactions": [
		47795,
		47795
	],
	"./it-IT/account-transactions.json": [
		47795,
		47795
	],
	"./it-IT/alerts-settings": [
		25245,
		25245
	],
	"./it-IT/alerts-settings.json": [
		25245,
		25245
	],
	"./it-IT/aria": [
		91867,
		91867
	],
	"./it-IT/aria.json": [
		91867,
		91867
	],
	"./it-IT/auto-savings": [
		69393,
		69393
	],
	"./it-IT/auto-savings.json": [
		69393,
		69393
	],
	"./it-IT/bad-request": [
		56223,
		56223
	],
	"./it-IT/bad-request.json": [
		56223,
		56223
	],
	"./it-IT/billing-address": [
		25377,
		25377
	],
	"./it-IT/billing-address.json": [
		25377,
		25377
	],
	"./it-IT/blog": [
		2521,
		63876
	],
	"./it-IT/blog-article": [
		16398,
		16398
	],
	"./it-IT/blog-article.json": [
		16398,
		16398
	],
	"./it-IT/blog-category": [
		81068,
		81068
	],
	"./it-IT/blog-category.json": [
		81068,
		81068
	],
	"./it-IT/blog-home": [
		59419,
		59419
	],
	"./it-IT/blog-home.json": [
		59419,
		59419
	],
	"./it-IT/blog-search": [
		68379,
		68379
	],
	"./it-IT/blog-search.json": [
		68379,
		68379
	],
	"./it-IT/blog-tag": [
		45575,
		45575
	],
	"./it-IT/blog-tag.json": [
		45575,
		45575
	],
	"./it-IT/blog.json": [
		2521,
		63876
	],
	"./it-IT/breadcrumb": [
		12358,
		12358
	],
	"./it-IT/breadcrumb.json": [
		12358,
		12358
	],
	"./it-IT/button": [
		20620,
		20620
	],
	"./it-IT/button.json": [
		20620,
		20620
	],
	"./it-IT/cart": [
		83504,
		83504
	],
	"./it-IT/cart.json": [
		83504,
		83504
	],
	"./it-IT/change-password": [
		13916,
		13916
	],
	"./it-IT/change-password.json": [
		13916,
		13916
	],
	"./it-IT/charts": [
		98591,
		98591
	],
	"./it-IT/charts.json": [
		98591,
		98591
	],
	"./it-IT/checkout": [
		86047,
		86047
	],
	"./it-IT/checkout-billing": [
		371,
		371
	],
	"./it-IT/checkout-billing.json": [
		371,
		371
	],
	"./it-IT/checkout-payment": [
		85630,
		85630
	],
	"./it-IT/checkout-payment.json": [
		85630,
		85630
	],
	"./it-IT/checkout-review": [
		60241,
		60241
	],
	"./it-IT/checkout-review.json": [
		60241,
		60241
	],
	"./it-IT/checkout-shipping": [
		36299,
		36299
	],
	"./it-IT/checkout-shipping.json": [
		36299,
		36299
	],
	"./it-IT/checkout-thank-you": [
		80466,
		80466
	],
	"./it-IT/checkout-thank-you.json": [
		80466,
		80466
	],
	"./it-IT/checkout.json": [
		86047,
		86047
	],
	"./it-IT/choice-purchasing-limit": [
		87218,
		87218
	],
	"./it-IT/choice-purchasing-limit.json": [
		87218,
		87218
	],
	"./it-IT/claims": [
		98710,
		98710
	],
	"./it-IT/claims.json": [
		98710,
		98710
	],
	"./it-IT/common": [
		57888,
		57888
	],
	"./it-IT/common.json": [
		57888,
		57888
	],
	"./it-IT/contact": [
		16887,
		16887
	],
	"./it-IT/contact-form": [
		86780,
		86780
	],
	"./it-IT/contact-form.json": [
		86780,
		86780
	],
	"./it-IT/contact.json": [
		16887,
		16887
	],
	"./it-IT/cookie-consent": [
		94505,
		94505
	],
	"./it-IT/cookie-consent.json": [
		94505,
		94505
	],
	"./it-IT/currency": [
		82506,
		82506
	],
	"./it-IT/currency.json": [
		82506,
		82506
	],
	"./it-IT/delivery-claims": [
		14989,
		14989
	],
	"./it-IT/delivery-claims-billing-address": [
		55093,
		55093
	],
	"./it-IT/delivery-claims-billing-address.json": [
		55093,
		55093
	],
	"./it-IT/delivery-claims-breakdown": [
		34787,
		34787
	],
	"./it-IT/delivery-claims-breakdown.json": [
		34787,
		34787
	],
	"./it-IT/delivery-claims-delivery": [
		57124,
		57124
	],
	"./it-IT/delivery-claims-delivery.json": [
		57124,
		57124
	],
	"./it-IT/delivery-claims-order-review": [
		8550,
		8550
	],
	"./it-IT/delivery-claims-order-review.json": [
		8550,
		8550
	],
	"./it-IT/delivery-claims-payment-method": [
		88113,
		88113
	],
	"./it-IT/delivery-claims-payment-method.json": [
		88113,
		88113
	],
	"./it-IT/delivery-claims-thank-you": [
		31325,
		31325
	],
	"./it-IT/delivery-claims-thank-you.json": [
		31325,
		31325
	],
	"./it-IT/delivery-claims.json": [
		14989,
		14989
	],
	"./it-IT/deposit": [
		95395,
		95395
	],
	"./it-IT/deposit.json": [
		95395,
		95395
	],
	"./it-IT/done-kyc": [
		52872,
		52872
	],
	"./it-IT/done-kyc.json": [
		52872,
		52872
	],
	"./it-IT/email-unsubscribe": [
		27895,
		27895
	],
	"./it-IT/email-unsubscribe.json": [
		27895,
		27895
	],
	"./it-IT/emergency-people": [
		47873,
		47873
	],
	"./it-IT/emergency-people.json": [
		47873,
		47873
	],
	"./it-IT/example": [
		94720,
		94720
	],
	"./it-IT/example.json": [
		94720,
		94720
	],
	"./it-IT/faq": [
		95790,
		95790
	],
	"./it-IT/faq-category": [
		63959,
		63959
	],
	"./it-IT/faq-category.json": [
		63959,
		63959
	],
	"./it-IT/faq-list": [
		49515,
		49515
	],
	"./it-IT/faq-list.json": [
		49515,
		49515
	],
	"./it-IT/faq-search": [
		73216,
		73216
	],
	"./it-IT/faq-search.json": [
		73216,
		73216
	],
	"./it-IT/faq.json": [
		95790,
		95790
	],
	"./it-IT/footer": [
		86845,
		86845
	],
	"./it-IT/footer.json": [
		86845,
		86845
	],
	"./it-IT/forgotten-password": [
		28126,
		28126
	],
	"./it-IT/forgotten-password.json": [
		28126,
		28126
	],
	"./it-IT/form": [
		86690,
		86690
	],
	"./it-IT/form.json": [
		86690,
		86690
	],
	"./it-IT/general-conditions": [
		68149,
		68149
	],
	"./it-IT/general-conditions.json": [
		68149,
		68149
	],
	"./it-IT/gift-confirmation": [
		74466,
		74466
	],
	"./it-IT/gift-confirmation.json": [
		74466,
		74466
	],
	"./it-IT/gift-detail": [
		60214,
		60214
	],
	"./it-IT/gift-detail.json": [
		60214,
		60214
	],
	"./it-IT/gift-list": [
		84782,
		84782
	],
	"./it-IT/gift-list.json": [
		84782,
		84782
	],
	"./it-IT/gift-pending": [
		97773,
		97773
	],
	"./it-IT/gift-pending.json": [
		97773,
		97773
	],
	"./it-IT/gift-recipient": [
		66123,
		66123
	],
	"./it-IT/gift-recipient.json": [
		66123,
		66123
	],
	"./it-IT/gift-submit": [
		90517,
		90517
	],
	"./it-IT/gift-submit.json": [
		90517,
		90517
	],
	"./it-IT/gifts": [
		70065,
		70065
	],
	"./it-IT/gifts.json": [
		70065,
		70065
	],
	"./it-IT/header": [
		50992,
		50992
	],
	"./it-IT/header.json": [
		50992,
		50992
	],
	"./it-IT/home": [
		37193,
		37193
	],
	"./it-IT/home-shop": [
		24892,
		24892
	],
	"./it-IT/home-shop.json": [
		24892,
		24892
	],
	"./it-IT/home.json": [
		37193,
		37193
	],
	"./it-IT/impressum": [
		87834,
		87834
	],
	"./it-IT/impressum.json": [
		87834,
		87834
	],
	"./it-IT/internal-error": [
		43081,
		43081
	],
	"./it-IT/internal-error.json": [
		43081,
		43081
	],
	"./it-IT/kyc": [
		25589,
		25589
	],
	"./it-IT/kyc-annual-income": [
		56586,
		56586
	],
	"./it-IT/kyc-annual-income.json": [
		56586,
		56586
	],
	"./it-IT/kyc-business-sector": [
		63101,
		63101
	],
	"./it-IT/kyc-business-sector.json": [
		63101,
		63101
	],
	"./it-IT/kyc-date-of-birth": [
		36290,
		36290
	],
	"./it-IT/kyc-date-of-birth.json": [
		36290,
		36290
	],
	"./it-IT/kyc-exposed-person": [
		24028,
		24028
	],
	"./it-IT/kyc-exposed-person.json": [
		24028,
		24028
	],
	"./it-IT/kyc-forecasted-annual-investments": [
		93688,
		93688
	],
	"./it-IT/kyc-forecasted-annual-investments.json": [
		93688,
		93688
	],
	"./it-IT/kyc-location": [
		87810,
		87810
	],
	"./it-IT/kyc-location.json": [
		87810,
		87810
	],
	"./it-IT/kyc-occupation": [
		70654,
		70654
	],
	"./it-IT/kyc-occupation.json": [
		70654,
		70654
	],
	"./it-IT/kyc-phone-number": [
		10464,
		10464
	],
	"./it-IT/kyc-phone-number.json": [
		10464,
		10464
	],
	"./it-IT/kyc-purchasing-limit": [
		79255,
		79255
	],
	"./it-IT/kyc-purchasing-limit.json": [
		79255,
		79255
	],
	"./it-IT/kyc-sources-of-funds": [
		84374,
		84374
	],
	"./it-IT/kyc-sources-of-funds.json": [
		84374,
		84374
	],
	"./it-IT/kyc.json": [
		25589,
		25589
	],
	"./it-IT/language": [
		90179,
		90179
	],
	"./it-IT/language.json": [
		90179,
		90179
	],
	"./it-IT/link": [
		77627,
		77627
	],
	"./it-IT/link.json": [
		77627,
		77627
	],
	"./it-IT/maintenance": [
		88397,
		88397
	],
	"./it-IT/maintenance.json": [
		88397,
		88397
	],
	"./it-IT/modal": [
		33875,
		33875
	],
	"./it-IT/modal.json": [
		33875,
		33875
	],
	"./it-IT/nationality": [
		9535,
		9535
	],
	"./it-IT/nationality.json": [
		9535,
		9535
	],
	"./it-IT/no_filename": [
		30962,
		30962
	],
	"./it-IT/no_filename.json": [
		30962,
		30962
	],
	"./it-IT/not-found": [
		60769,
		60769
	],
	"./it-IT/not-found.json": [
		60769,
		60769
	],
	"./it-IT/occupation": [
		73954,
		73954
	],
	"./it-IT/occupation.json": [
		73954,
		73954
	],
	"./it-IT/onfido": [
		44506,
		44506
	],
	"./it-IT/onfido.json": [
		44506,
		44506
	],
	"./it-IT/origin-of-funds": [
		75695,
		75695
	],
	"./it-IT/origin-of-funds.json": [
		75695,
		75695
	],
	"./it-IT/page-profile": [
		2948,
		2948
	],
	"./it-IT/page-profile.json": [
		2948,
		2948
	],
	"./it-IT/password-settings": [
		52235,
		52235
	],
	"./it-IT/password-settings.json": [
		52235,
		52235
	],
	"./it-IT/payments": [
		12845,
		12845
	],
	"./it-IT/payments.json": [
		12845,
		12845
	],
	"./it-IT/photo-identification": [
		67191,
		67191
	],
	"./it-IT/photo-identification.json": [
		67191,
		67191
	],
	"./it-IT/precious-metal": [
		83000,
		83000
	],
	"./it-IT/precious-metal.json": [
		83000,
		83000
	],
	"./it-IT/pricing": [
		54097,
		54097
	],
	"./it-IT/pricing.json": [
		54097,
		54097
	],
	"./it-IT/privacy": [
		12286,
		12286
	],
	"./it-IT/privacy.json": [
		12286,
		12286
	],
	"./it-IT/product": [
		14788,
		14788
	],
	"./it-IT/product-show": [
		74187,
		74187
	],
	"./it-IT/product-show.json": [
		74187,
		74187
	],
	"./it-IT/product.json": [
		14788,
		14788
	],
	"./it-IT/profile": [
		24775,
		24775
	],
	"./it-IT/profile.json": [
		24775,
		24775
	],
	"./it-IT/proof-of-address": [
		5357,
		5357
	],
	"./it-IT/proof-of-address.json": [
		5357,
		5357
	],
	"./it-IT/purchasing-limit": [
		7462,
		7462
	],
	"./it-IT/purchasing-limit.json": [
		7462,
		7462
	],
	"./it-IT/referral-terms": [
		56146,
		56146
	],
	"./it-IT/referral-terms.json": [
		56146,
		56146
	],
	"./it-IT/referrals": [
		87981,
		87981
	],
	"./it-IT/referrals.json": [
		87981,
		87981
	],
	"./it-IT/request-a-call": [
		48102,
		48102
	],
	"./it-IT/request-a-call.json": [
		48102,
		48102
	],
	"./it-IT/resend-instruction": [
		48383,
		48383
	],
	"./it-IT/resend-instruction.json": [
		48383,
		48383
	],
	"./it-IT/resend-instructions": [
		31943,
		31943
	],
	"./it-IT/resend-instructions.json": [
		31943,
		31943
	],
	"./it-IT/residence": [
		42761,
		42761
	],
	"./it-IT/residence.json": [
		42761,
		42761
	],
	"./it-IT/route": [
		70007,
		70007
	],
	"./it-IT/route.json": [
		70007,
		70007
	],
	"./it-IT/saving-assistant": [
		69348,
		69348
	],
	"./it-IT/saving-assistant.json": [
		69348,
		69348
	],
	"./it-IT/search": [
		76226,
		76226
	],
	"./it-IT/search.json": [
		76226,
		76226
	],
	"./it-IT/shipping-address": [
		57919,
		57919
	],
	"./it-IT/shipping-address.json": [
		57919,
		57919
	],
	"./it-IT/shop": [
		70449,
		70449
	],
	"./it-IT/shop-subcategory": [
		84349,
		84349
	],
	"./it-IT/shop-subcategory.json": [
		84349,
		84349
	],
	"./it-IT/shop.json": [
		70449,
		70449
	],
	"./it-IT/sign-in": [
		59168,
		59168
	],
	"./it-IT/sign-in.json": [
		59168,
		59168
	],
	"./it-IT/sign-up": [
		64962,
		64962
	],
	"./it-IT/sign-up.json": [
		64962,
		64962
	],
	"./it-IT/silver-landing": [
		75614,
		75614
	],
	"./it-IT/silver-landing.json": [
		75614,
		75614
	],
	"./it-IT/storage-fees": [
		44717,
		44717
	],
	"./it-IT/storage-fees.json": [
		44717,
		44717
	],
	"./it-IT/storage-solution": [
		42105,
		42105
	],
	"./it-IT/storage-solution.json": [
		42105,
		42105
	],
	"./it-IT/table": [
		25886,
		25886
	],
	"./it-IT/table.json": [
		25886,
		25886
	],
	"./it-IT/tooltip": [
		46413,
		46413
	],
	"./it-IT/tooltip.json": [
		46413,
		46413
	],
	"./it-IT/tutorial-video": [
		7113,
		7113
	],
	"./it-IT/tutorial-video.json": [
		7113,
		7113
	],
	"./it-IT/tutorial-videos": [
		97038,
		97038
	],
	"./it-IT/tutorial-videos.json": [
		97038,
		97038
	],
	"./it-IT/two-steps-auth": [
		68143,
		68143
	],
	"./it-IT/two-steps-auth-sms": [
		61790,
		61790
	],
	"./it-IT/two-steps-auth-sms.json": [
		61790,
		61790
	],
	"./it-IT/two-steps-auth-totp": [
		61458,
		61458
	],
	"./it-IT/two-steps-auth-totp.json": [
		61458,
		61458
	],
	"./it-IT/two-steps-auth.json": [
		68143,
		68143
	],
	"./it-IT/unlock-account": [
		26431,
		26431
	],
	"./it-IT/unlock-account.json": [
		26431,
		26431
	],
	"./it-IT/user": [
		67348,
		67348
	],
	"./it-IT/user.json": [
		67348,
		67348
	],
	"./it-IT/validator": [
		85276,
		85276
	],
	"./it-IT/validator.json": [
		85276,
		85276
	],
	"./it-IT/verify-auth": [
		6662,
		6662
	],
	"./it-IT/verify-auth.json": [
		6662,
		6662
	],
	"./it-IT/wallet": [
		78390,
		78390
	],
	"./it-IT/wallet-auto-savings": [
		44555,
		44555
	],
	"./it-IT/wallet-auto-savings-show": [
		17048,
		13899
	],
	"./it-IT/wallet-auto-savings-show.json": [
		17048,
		13899
	],
	"./it-IT/wallet-auto-savings.json": [
		44555,
		44555
	],
	"./it-IT/wallet-claim-show": [
		66290,
		66290
	],
	"./it-IT/wallet-claim-show.json": [
		66290,
		66290
	],
	"./it-IT/wallet-claims": [
		20578,
		20578
	],
	"./it-IT/wallet-claims.json": [
		20578,
		20578
	],
	"./it-IT/wallet-gift-show": [
		42203,
		42203
	],
	"./it-IT/wallet-gift-show.json": [
		42203,
		42203
	],
	"./it-IT/wallet-gifts": [
		72467,
		72467
	],
	"./it-IT/wallet-gifts.json": [
		72467,
		72467
	],
	"./it-IT/wallet-order-show": [
		34589,
		34589
	],
	"./it-IT/wallet-order-show.json": [
		34589,
		34589
	],
	"./it-IT/wallet-orders": [
		70534,
		70534
	],
	"./it-IT/wallet-orders.json": [
		70534,
		70534
	],
	"./it-IT/wallet-page": [
		47024,
		47024
	],
	"./it-IT/wallet-page.json": [
		47024,
		47024
	],
	"./it-IT/wallet-sell": [
		7616,
		7616
	],
	"./it-IT/wallet-sell-review": [
		11340,
		11340
	],
	"./it-IT/wallet-sell-review.json": [
		11340,
		11340
	],
	"./it-IT/wallet-sell-thanks": [
		50145,
		50145
	],
	"./it-IT/wallet-sell-thanks.json": [
		50145,
		50145
	],
	"./it-IT/wallet-sell.json": [
		7616,
		7616
	],
	"./it-IT/wallet.json": [
		78390,
		78390
	],
	"./it-IT/widget": [
		15140,
		15140
	],
	"./it-IT/widget.json": [
		15140,
		15140
	],
	"./it-IT/wishlist": [
		51050,
		51050
	],
	"./it-IT/wishlist.json": [
		51050,
		51050
	],
	"./it-IT/withdrawal": [
		9058,
		9058
	],
	"./it-IT/withdrawal.json": [
		9058,
		9058
	],
	"./it-IT/your-project": [
		40514,
		40514
	],
	"./it-IT/your-project.json": [
		40514,
		40514
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 33650;
module.exports = webpackAsyncContext;